// extracted by mini-css-extract-plugin
export default {"loadingPanel":"ProtectedRoute_loadingPanel__fApwR"};